import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["carousel"]

  get isRtl() {
    return document.documentElement.dir === 'rtl'
  }

  previous(event) {
    const baseScroll = event.currentTarget.dataset.size === "sm" ? 256 : 272
    // In RTL, scrolling "previous" means scrolling right (positive), in LTR it means scrolling left (negative)
    const left = this.isRtl ? baseScroll : -baseScroll

    this.carouselTarget.scrollBy({
      left: left,
      behavior: 'smooth'
    });
  }

  next(event) {
    const baseScroll = event.currentTarget.dataset.size === "sm" ? 256 : 272
    // In RTL, scrolling "next" means scrolling left (negative), in LTR it means scrolling right (positive)
    const left = this.isRtl ? -baseScroll : baseScroll

    this.carouselTarget.scrollBy({
      left: left, 
      behavior: 'smooth'
    });
  }
} 